exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".order-form[data-v-259700db] {\n  border: 1px solid var(--dark);\n}\n@media screen and (max-width: 1023.98px) {\n.order-form[data-v-259700db] {\n    border: none;\n}\n}", ""]);

// exports
